import React from 'react';
import {isMobile} from "../commonmethod/CommonMethod";

function TabChartHeader({args, setArgs, className, disable, title, variant = "default", tabPrefix = null}) {

    const openListener = (idx) => {
        const arr = [];
        args.forEach((e, tdx) => {
            if (idx === tdx) {
                e.clicked = true
                arr.push(e)
            } else {
                e.clicked = false;
                arr.push(e)
            }
        });
        setArgs(arr)
    }

    if (variant === "split") {
        return (
            <div className="flex w-full items-center gap-[6px] md:justify-between md:gap-3 md:bg-white md:px-[16px]">
                {title && (
                    <h3 className="hidden shrink-0 text-[21px] font-bold leading-none text-[#333] md:block">
                        {title}
                    </h3>
                )}
                <div className="flex w-full min-w-0 items-center gap-[6px] md:w-auto md:flex-wrap md:justify-end md:gap-[8px]">
                    {tabPrefix}
                    {args.map((each, idx) => (
                        <button
                            key={idx}
                            type="button"
                            disabled={disable}
                            title={each.name}
                            className={[
                                "rounded-[6px] border py-[6px] text-[12px] font-medium transition-colors outline-none",
                                "focus:outline-none focus-visible:outline-none",
                                "min-w-0 flex-1 truncate px-[8px] text-center md:flex-none md:whitespace-nowrap md:px-[14px] md:text-left",
                                each.clicked
                                    ? "border-[#3b82f6] bg-white text-[#3b82f6]"
                                    : "border-[#d9d9d9] bg-[#f5f5f5] text-[#666] hover:border-[#bbb]",
                                disable ? "cursor-default opacity-70" : "cursor-pointer",
                            ].join(" ")}
                            onClick={() => {
                                if (!disable) openListener(idx);
                            }}
                        >
                            {each.name}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className={`scroll-hidden className content-bold ${isMobile? 'mobile-chart-tab':'tab-chart-group'}`}>
            {args.map((each, idx) => (
                <div
                    key={idx}
                    className={`${className} tab-chart ${each.clicked ? 'tab-chart-item-selected' : ''}`}
                    style={{ width: `${100 / args.length}%` }}
                    onClick={() => {if(!disable) openListener(idx)}}
                >
                    {each.name}
                </div>
            ))}
        </div>
    );
}

export default TabChartHeader;
